import { CLIENT } from '../config';

export enum Clients {
  Incrowd = 'apollo',
  Netquest = 'netquest',
  PureProfile = 'pureprofile',
  Sightx = 'sightx',
  Meta = 'meta',
  MetaDIY = 'meta-diy',
}

export const isIncrowdClient = (): boolean => {
  return CLIENT === Clients.Incrowd;
};

export const isNetquestClient = (): boolean => Clients.Netquest === CLIENT;

export const isPureProfileClient = (): boolean => CLIENT === Clients.PureProfile;

export const isMetaClient = (): boolean => CLIENT === Clients.Meta;

// TODO: SIG-20312 add tests
export const isMetaDIYClient = (): boolean => CLIENT === Clients.MetaDIY;

export const isExternalClient = (): boolean => isNetquestClient() || isPureProfileClient() || isMetaClient() || isMetaDIYClient();
